<template>
  <banner>
    <div class="flex-center">
      <div class="text-normal-1 bold">This is a demo account.</div>
      &nbsp;
      <div class="text-medium-1 text-medium-1 mr-2">
        It will be permanently deleted {{ expiresIn }}.
      </div>
      <request-demo-link :org-id="orgId" />
    </div>
  </banner>
</template>

<script>
import Banner from '@/components/Banner.vue'
import RequestDemoLink from '@/components/RequestDemoLink.vue'

/**
 * This is a banner for demo org. It acts as an indicator. It also shows the duration in which org is going to get auto-deleted.
 */
export default {
  name: 'DemoOrgBar',
  props: ['orgId'],
  components: { RequestDemoLink, Banner },
  data() {
    return {}
  },
  computed: {
    org() {
      return this.$store.getters.orgById(this.orgId)
    },
    expiresIn() {
      return this.getRelativeTime(this.org.demoOrgExpiresOn)
    }
  },
  methods: {
    formatRelativeTime(msDifference) {
      const seconds = Math.max(Math.floor(msDifference / 1000), 0)
      const minutes = Math.floor(seconds / 60)
      const hours = Math.floor(minutes / 60)
      const days = Math.floor(hours / 24)

      if (days === 0) {
        if (hours === 0) {
          if (minutes === 0) {
            if (seconds === 0) {
              return 'any minute now'
            } else if (seconds < 60) {
              return seconds === 1 ? 'in 1 second' : `in ${seconds} seconds`
            } else {
              return 'today'
            }
          } else {
            return minutes === 1 ? 'in 1 minute' : `in ${minutes} minutes`
          }
        } else if (hours === 1) {
          return 'in 1 hour'
        } else {
          return `in ${hours} hours`
        }
      } else if (days === 1) {
        return 'tomorrow'
      } else {
        return `in ${days} days`
      }
    },
    getRelativeTime(dateISO) {
      const date = new Date(dateISO)
      const currentDate = new Date()
      const timeDifference = date - currentDate
      return this.formatRelativeTime(timeDifference)
    }
  },
  mounted() {}
}
</script>

<style lang="scss" scoped></style>
